var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.9 1029.8c-16.1 0-30.1-12-32.2-28.5-.3-2.3-7-58.3 10.5-134.5 10.2-44.5 26.7-87 48.9-126.5 27.7-49.2 64.4-93.7 109.1-132 45-38.6 96.1-67.9 152-87 44.5-15.3 92.1-24.2 141.4-26.5 77.4-3.6 134.7 10.3 145 13 16.6 3.2 143 31 247.3 147.8 49 54.9 83.9 118.9 103.5 190.1 19 68.9 18.4 125.6 16.3 153.2-1.3 17.9-16.9 31.3-34.8 30-17.9-1.3-31.3-16.9-30-34.8 2.9-38.8 4-174.8-103.5-295.2-48.8-54.7-103.5-86.3-140.8-103.2-40.9-18.6-70.6-24.1-70.9-24.1-1.1-.2-2-.4-3.1-.7-.5-.1-54.3-14.7-128.2-10.9-97.3 5-182 37.9-251.9 97.8C68.3 802 89.9 991.4 90.2 993.3c2.2 17.8-10.4 34.1-28.2 36.3-1.4.2-2.8.2-4.1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M511.8 83.2c54.8 0 106.2 21.3 145 60 38.7 38.7 60 90.2 60 145s-21.3 106.2-60 145c-38.7 38.7-90.2 60-145 60s-106.2-21.3-145-60c-38.7-38.7-60-90.2-60-145s21.3-106.2 60-145c38.7-38.7 90.2-60 145-60m0-65c-149.1 0-270 120.9-270 270s120.9 270 270 270 270-120.9 270-270-120.9-270-270-270z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default ForwardRef;